import { Link } from "react-router-dom";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card } from "@/components/ui/card";
import { ArrowDown } from "lucide-react";

interface LeaderboardEntry {
  user_id: string;
  username: string;
  name: string | null;
  image: string | null;
  image_thumb: string | null;
  level: number;
  level_title: string | null;
  rank: number;
}

interface MyRankCardProps {
  entry: LeaderboardEntry;
  statLabel: string;
  statValue: string;
}

export function MyRankCard({ entry, statLabel, statValue }: MyRankCardProps) {
  return (
    <Card className="p-4 bg-primary/5 border-primary mb-6">
      <div className="flex items-center gap-3 mb-2">
        <ArrowDown className="h-5 w-5 text-primary" />
        <span className="text-sm font-semibold text-primary">Your Rank</span>
      </div>
      
      <Link to={`/u/${entry.username}`} className="flex items-center gap-4">
        <div className="shrink-0 w-10 h-10 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-bold">
          #{entry.rank}
        </div>

        <Avatar className="h-12 w-12">
          <AvatarImage src={entry.image_thumb || entry.image || undefined} />
          <AvatarFallback>{entry.username[0].toUpperCase()}</AvatarFallback>
        </Avatar>

        <div className="flex-1 min-w-0">
          <div className="font-semibold truncate">
            {entry.name || entry.username}
          </div>
          <div className="text-sm text-muted-foreground">
            Level {entry.level} {entry.level_title && `• ${entry.level_title}`}
          </div>
        </div>

        <div className="text-right shrink-0">
          <div className="text-2xl font-bold text-primary">{statValue}</div>
          <div className="text-xs text-muted-foreground">{statLabel}</div>
        </div>
      </Link>
    </Card>
  );
}
